import CbInputGroup from './src/input-group.vue';

CbInputGroup.install = function(Vue) {
  Vue.component(CbInputGroup.name, CbInputGroup);
};

export default CbInputGroup;
